<div class="login-header">
    <img class="ddj-logo" src="{{ companyImage }}" alt="ddj logo" [routerLink]="['login']" />
    <img
        id="product-image"
        [class]="productImage === '../../assets/img/ez-docs-logo-white.png' ? 'product-img ez-docs' : 'product-img'"
        src="{{ productImage }}"
        alt="unite digital logo"
    />
</div>
<section class="system-doc-container">
    <accept-terms [requiredDocs]="requiredDocs" (outEvent)="eventHandler($event)"></accept-terms>
</section>
<app-footer [hideVersion]="true"></app-footer>
